import {
  CONSOLIDATION_INFO_REQUEST,
  CONSOLIDATION_INFO_SUCCESS,
  CONSOLIDATION_INFO_FAILURE,
  SAVE_CONSOLIDATION_REQUEST,
  SAVE_CONSOLIDATION_SUCCESS,
  SAVE_CONSOLIDATION_FAILURE,
  GET_CONSOLIDATION_RMBAL_REQUEST,
  GET_CONSOLIDATION_RMBAL_SUCCESS,
  GET_CONSOLIDATION_RMBAL_FAILURE,
  CALCULATE_CONSOLIDATION_REQUEST,
  CALCULATE_CONSOLIDATION_SUCCESS,
  CALCULATE_CONSOLIDATION_FAILURE,
  SET_NEW_COLLATERAL_ITEM,
  SET_CURRENT_COLLATERAL_ITEM,
  SET_SSN,
  SET_MILAGE,
  SET_NEW_COLLATERAL_AMOUNT,
  SET_CURRENT_COLLATERAL_AMOUNT,
  SET_COLLATERAL_REDEMPTION,
  SET_COLLATERAL_REDEMPTION_AND_CLEAR_LICENSE_PLATE_CHANGED,
  SET_COLLATERAL_VALUE,
  SET_ADDITIONAL_DEPOSIT,
  SET_INITIAL_DEPOSIT,
  SET_CAR_INSURANCE_COMPANY,
  SET_CAR_INSURANCE_COMPANIES,
  CAR_INFO_REQUEST,
  CAR_INFO_SUCCESS,
  CAR_INFO_FAILURE,
  RESET_CONSOLIDATION_STATE,
  SET_TERMS_DUE_DATE_COUNT,
  GET_PERSON_NAME_REQUEST,
  GET_PERSON_NAME_FAILURE,
  GET_SELLER_NAME_SUCCESS,
  CURRENT_CAR_INFO_REQUEST,
  CURRENT_CAR_INFO_SUCCESS,
  CURRENT_CAR_INFO_FAILURE,
  SET_DEPOSIT_PERCENTAGE,
  SET_LOAN_TYPE,
  CLEAR_RMBAL_FLAGS,
} from "./constants";

import { Api, notifications } from "../../utils";
import { createAndShowBlobFile } from "../../utils/helpers";
import { push } from "connected-react-router";
import {
  setApplicantField,
  setSecondApplicantField,
  setGuarantorField,
  setCommunication,
  setSecondGuarantorField,
  setSellerField,
  getApplicantName,
  getSecondApplicantName,
  getGuarantorName,
  getSecondGuarantorName,
  getSellerName,
  resetApplicant,
  resetSecondApplicant,
  resetSecondApplicantField,
  resetGuarantorFields,
  resetSecondGuarantorFields
} from "../app/actions";

const saveConsolidationRequest = (request) => ({
  type: SAVE_CONSOLIDATION_REQUEST,
  request,
});

const saveConsolidationSuccess = (data) => ({
  type: SAVE_CONSOLIDATION_SUCCESS,
  data,
});

const saveConsolidationFailure = (error) => ({
  type: SAVE_CONSOLIDATION_FAILURE,
  error,
});


const prepareData = (getState, isCalc, statusOverride) => {
  const { app, consolidation, auth } = getState()
  if (
    isCalc &&
    consolidation.newCollateral?.salesAmt == null
  ) {
    return null;
  }

  const applicants = [];
  if (consolidation.applicant && consolidation.applicant.ssn) applicants.push({...consolidation.applicant, type: 1})
  else if (app.applicant && app.applicant.ssn) applicants.push({...app.applicant, type: 1})
  if (consolidation.secondApplicant && consolidation.secondApplicant.ssn) applicants.push({...consolidation.secondApplicant, type: 2})
  else if (app.secondApplicant && app.secondApplicant.ssn) applicants.push({...app.secondApplicant, type: 2})

  if (consolidation.guarantor && consolidation.guarantor.ssn) applicants.push({...consolidation.guarantor, type: 4})
  else if (app.guarantor && app.guarantor.ssn) applicants.push({...app.guarantor, type: 4})
  if (consolidation.guarantor2 && consolidation.guarantor2.ssn) applicants.push({...consolidation.guarantor2, type: 7})
  else if (app.guarantor2 && app.guarantor2.ssn) applicants.push({...app.guarantor2, type: 7})
  if (consolidation.ssn != "") applicants.push({ssn: consolidation.ssn, type: 5})

  const data = {
    newCollateral: consolidation.newCollateral,
    currentCollateral: consolidation.currentCollateral,
    resellerStaffId: auth.user.username,
    resellerCompanyId: auth.user.sellerSSN,
    year: consolidation.year, // APPL_YEAR
    serialNumber: consolidation.serialNumber, // APPL_NO
    status: statusOverride || consolidation.status, // APPL_STATUS
    subStatus: consolidation.subStatus, // APPL_SUBSTATUS
    statusText: consolidation.statusText, // STATUS_TEXT
    productType: consolidation.productType, // PRODUCT_TYPE
    productText: consolidation.productText, // PRODUCT_TEXT
    initialDeposit: consolidation.initialDeposit, // INITIAL_LOAN_DEPOSIT_AMNT
    additionalCashDeposit: consolidation.additionalCashDeposit, // ADDITIONAL_LOAN_DEPOSIT_AMNT
    commitmentFee: consolidation.commitmentFee, // COMMITMENT_FEE_AMNT
    commitmentFeePct: consolidation.commitmentFeePct, // COMMITMENT_FEE_PCT
    commitmentFeeCategory: consolidation.commitmentFeeCategory, // COMMITMENT_FEE_CODE
    registrationFee: consolidation.registrationFee, // REGISTRATION_FEE_AMNT
    registrationFeeClassification: consolidation.registrationFeeClassification, // REGISTRATION_FEE_CODE
    administrationFee: consolidation.administrationFee, // ADMINISTRATION_FEE_AMNT
    administrationFeeClassification: consolidation.administrationFeeClassification, // ADMINISTRATION_FEE_CODE
    finalFee: consolidation.finalFee, // FINAL_PAYMENT_FEE_AMNT
    loanNetAmount: consolidation.loanNetAmount, // LOAN_NET_AMNT
    paymentToSeller: consolidation.paymentToSeller, // PAYMENT_OUT_AMNT
    dueDateCount: consolidation.dueDateCount, // NO_OF_DUE_DATES
    firstDueDate: consolidation.firstDueDate, // FIRST_PAYMENT_DATE
    interestRate: consolidation.interestRate, // INTEREST_RATE
    annualCostRatio: consolidation.annualCostRatio, // ANNUAL_COST_RATIO
    plannedFirstPayment: consolidation.plannedFirstPayment, // ESTIMATED_FIRST_PAYMENT_AMNT
    plannedAveragePayment: consolidation.plannedAveragePayment, // ESTIMATED_PAYMENT_AMNT
    currency: consolidation.currency, // LOANCURRENCY
    disposalInformation: consolidation.disposalInformation, // DISPOSAL_INFORMATION_CD
    sendContract: consolidation.sendContract, // SEND_CONTRACT_CODE
    sendDocument: consolidation.sendDocument, // SEND_DOCUMENT_FLG
    sendDocumentCount: consolidation.sendDocumentCount, // SEND_DOCUMENT_CNT
    message1: consolidation.message1, // MESSAGE_1_TXT
    message2: consolidation.message2, // MESSAGE_2_TXT
    conversation: app.communication, // CONVERSATION
    documentPDF: consolidation.documentPDF, // DOCUMENT_PDFX
    collateralContractAssigned: consolidation.collateralContractAssigned, // COLLATERAL_CONTRACT_ASSIGNED
    collateralValue: consolidation.collateralValue, // COLLATERAL_VALUE_AMNT
    collateralRedemption: consolidation.collateralRedemption, // COLLATERAL_REDEMPTION_AMNT
    applicants: applicants,    
  };
  
  return data;
}

export const saveConsolidation = (status) => (dispatch, getState) => {
  const data = prepareData(getState, false, status);

  dispatch(saveConsolidationRequest());
  return Api.consolidation
    .save(data)
    .then((res) => {
      dispatch(saveConsolidationSuccess(res.data));

      // Sync conversation to app.communication so SmartMessage displays it
      if (res.data.conversation) {
        dispatch(setCommunication(res.data.conversation));
      }

      dispatch(notifications.successNotification('Application.Saved'));
      dispatch(push('/'));
      dispatch(resetConsolidationState());
    })
    .catch((err) => {
      dispatch(saveConsolidationFailure(err));
    });
};

const getConsolidationRmBalRequest = (request) => ({
  type: GET_CONSOLIDATION_RMBAL_REQUEST,
  request,
});

const getConsolidationRmBalSuccess = (data) => ({
  type: GET_CONSOLIDATION_RMBAL_SUCCESS,
  data,
});

const getConsolidationRmBalFailure = (error) => ({
  type: GET_CONSOLIDATION_RMBAL_FAILURE,
  error,
});

export const getConsolidationRmBal = () => (dispatch, getState) => {
  const data = prepareData(getState, false);

  dispatch(getConsolidationRmBalRequest());
  return Api.consolidation
    .rmBal(data)
    .then((res) => {
      dispatch(getConsolidationRmBalSuccess(res.data));

      // Sync conversation to app.communication so SmartMessage displays it
      if (res.data.conversation) {
        dispatch(setCommunication(res.data.conversation));
      }

      // Set applicant states based on response data
      if (res.data.applicants) {
        res.data.applicants.forEach(applicant => {
          switch(applicant.type) {
            case 1: // Main applicant
              dispatch(setApplicantField('ssn', applicant.ssn));
              dispatch(setApplicantField('email', applicant.email));
              dispatch(setApplicantField('telephone', applicant.telephone));
              dispatch(getApplicantName(applicant.ssn));
              break;
            case 2: // Second applicant
              dispatch(setSecondApplicantField('ssn', applicant.ssn));
              dispatch(setSecondApplicantField('email', applicant.email));
              dispatch(setSecondApplicantField('telephone', applicant.telephone));
              dispatch(getSecondApplicantName(applicant.ssn));
              break;
            case 4: // Guarantor
              dispatch(setGuarantorField('ssn', applicant.ssn));
              dispatch(setGuarantorField('email', applicant.email));
              dispatch(setGuarantorField('telephone', applicant.telephone));
              dispatch(getGuarantorName(applicant.ssn));
              break;
            case 7: // Second guarantor
              dispatch(setSecondGuarantorField('ssn', applicant.ssn));
              dispatch(setSecondGuarantorField('email', applicant.email));
              dispatch(setSecondGuarantorField('telephone', applicant.telephone));
              dispatch(getSecondGuarantorName(applicant.ssn));
              break;
            case 5: // Seller
              dispatch(setSellerSsnAndGetName(applicant.ssn))
              break;
          }
        });
      }
    })
    .catch((err) => {
      dispatch(getConsolidationRmBalFailure(err));
    });
};

const calcConsolidationRequest = (request) => ({
  type: CALCULATE_CONSOLIDATION_REQUEST,
  request,
});

const calcConsolidationSuccess = (data) => ({
  type: CALCULATE_CONSOLIDATION_SUCCESS,
  data,
});

const calcConsolidationFailure = (error) => ({
  type: CALCULATE_CONSOLIDATION_FAILURE,
  error,
});

export const calcConsolidation = (getPDF = false) => (dispatch, getState) => {
  const data = prepareData(getState, true);
  if (data == null) return;

  dispatch(calcConsolidationRequest());
  return Api.consolidation
    .calc(data, getPDF)
    .then((res) => {
      if (getPDF && res.data.documentPDF) {
        createAndShowBlobFile(res.data.documentPDF);
      }

      dispatch(calcConsolidationSuccess(res.data));

      // Sync conversation to app.communication so SmartMessage displays it
      if (res.data.conversation) {
        dispatch(setCommunication(res.data.conversation));
      }

      // Set applicant states based on calculation response
      if (res.data.applicants) {
        res.data.applicants.forEach(applicant => {
          switch(applicant.type) {
            case 1:
              dispatch(setApplicantField('ssn', applicant.ssn));
              dispatch(setApplicantField('email', applicant.email));
              dispatch(setApplicantField('telephone', applicant.telephone));
              dispatch(getApplicantName(applicant.ssn));
              break;
            case 2:
              dispatch(setSecondApplicantField('ssn', applicant.ssn));
              dispatch(setSecondApplicantField('email', applicant.email));
              dispatch(setSecondApplicantField('telephone', applicant.telephone));
              dispatch(getSecondApplicantName(applicant.ssn));
              break;
            case 4:
              dispatch(setGuarantorField('ssn', applicant.ssn));
              dispatch(setGuarantorField('email', applicant.email));
              dispatch(setGuarantorField('telephone', applicant.telephone));
              dispatch(getGuarantorName(applicant.ssn));
              break;
            case 7:
              dispatch(setSecondGuarantorField('ssn', applicant.ssn));
              dispatch(setSecondGuarantorField('email', applicant.email));
              dispatch(setSecondGuarantorField('telephone', applicant.telephone));
              dispatch(getSecondGuarantorName(applicant.ssn));
              break;
            case 5:
              dispatch(setSellerSsnAndGetName(applicant.ssn))
              break;
          }
        });
      }
    })
    .catch((err) => {
      dispatch(calcConsolidationFailure(err));
    });
};

const consolidationInfoRequest = (request) => ({
  type: CONSOLIDATION_INFO_REQUEST,
  request,
});

const consolidationInfoSuccess = (data) => ({
  type: CONSOLIDATION_INFO_SUCCESS,
  data,
});

const consolidationInfoFailure = (error) => ({
  type: CONSOLIDATION_INFO_FAILURE,
  error,
});

export const getConsolidationInfo = (data) => (dispatch) => {
  dispatch(consolidationInfoRequest());
  return Api.consolidation
    .get(data)
    .then((res) => {
      dispatch(consolidationInfoSuccess(res.data));

      // Sync conversation to app.communication so SmartMessage displays it
      if (res.data.conversation) {
        dispatch(setCommunication(res.data.conversation));
      }

      // Set applicant states based on calculation response
      if (res.data.applicants) {
        res.data.applicants.forEach(applicant => {
          switch(applicant.type) {
            case 1:
              dispatch(setApplicantField('ssn', applicant.ssn));
              dispatch(setApplicantField('email', applicant.email));
              dispatch(setApplicantField('telephone', applicant.telephone));
              dispatch(getApplicantName(applicant.ssn));
              break;
            case 2:
              dispatch(setSecondApplicantField('ssn', applicant.ssn));
              dispatch(setSecondApplicantField('email', applicant.email));
              dispatch(setSecondApplicantField('telephone', applicant.telephone));
              dispatch(getSecondApplicantName(applicant.ssn));
              break;
            case 4:
              dispatch(setGuarantorField('ssn', applicant.ssn));
              dispatch(setGuarantorField('email', applicant.email));
              dispatch(setGuarantorField('telephone', applicant.telephone));
              dispatch(getGuarantorName(applicant.ssn));
              break;
            case 7:
              dispatch(setSecondGuarantorField('ssn', applicant.ssn));
              dispatch(setSecondGuarantorField('email', applicant.email));
              dispatch(setSecondGuarantorField('telephone', applicant.telephone));
              dispatch(getSecondGuarantorName(applicant.ssn));
              break;
            case 5:
              dispatch(setSellerSsnAndGetName(applicant.ssn))
              break;
          }
        });
      }

      // Return res so calling code can access res.data
      return res;
    })
    .catch((err) => {
      dispatch(consolidationInfoFailure(err));
      throw err;
    });
};

export const setNewCollateralItem = (collateralItem) => ({
  type: SET_NEW_COLLATERAL_ITEM,
  collateralItem,
});

export const setCurrentCollateralItem = (collateralItem) => ({
  type: SET_CURRENT_COLLATERAL_ITEM,
  collateralItem,
});

export const setSsn = (ssn) => ({
  type: SET_SSN,
  ssn,
});

export const setMilage = (collateralMilage) => ({
  type: SET_MILAGE,
  collateralMilage,
});

export const setNewCollateralAmount = (amount) => ({
  type: SET_NEW_COLLATERAL_AMOUNT,
  amount,
});

export const setCurrentCollateralAmount = (amount) => ({
  type: SET_CURRENT_COLLATERAL_AMOUNT,
  amount,
});

export const setCollateralRedemption = (amount) => ({
  type: SET_COLLATERAL_REDEMPTION,
  amount,
});

export const setCollateralRedemptionAndClearLicensePlateChanged = () => ({
  type: SET_COLLATERAL_REDEMPTION_AND_CLEAR_LICENSE_PLATE_CHANGED,
});

export const setCollateralValue = (amount) => ({
  type: SET_COLLATERAL_VALUE,
  amount,
});

export const setAdditionalDeposit = (amount) => ({
  type: SET_ADDITIONAL_DEPOSIT,
  amount,
});

export const setTermsDueDateCount = (dueDateCount) => ({
  type: SET_TERMS_DUE_DATE_COUNT,
  dueDateCount,
});


export const setInitialDeposit = (amount) => ({
  type: SET_INITIAL_DEPOSIT,
  amount,
});

const carInfoRequest = () => ({
  type: CAR_INFO_REQUEST,
});

const carInfoSuccess = (car) => ({
  type: CAR_INFO_SUCCESS,
  car,
});

const carInfoFailure = (error) => ({
  type: CAR_INFO_FAILURE,
  error,
});

export const getCarInfo = (id) => (dispatch, getState) => {
  dispatch(carInfoRequest());
  const { year, serialNumber } = getState().app;
  return Api.getVehicle(id, year, serialNumber)
    .then((res) => {
      dispatch(carInfoSuccess(res.data));
      dispatch(setSsn(res.data.ownerRegistryId));
      dispatch(getConsolidationSellerName(res.data.ownerRegistryId));
    })
    .catch((err) => {
      dispatch(carInfoFailure(err));
    });
};

export const setCarInsuranceCompany = (insuranceCompanyId) => ({
  type: SET_CAR_INSURANCE_COMPANY,
  insuranceCompanyId,
});

const setCarInsuranceCompanies = (carInsuranceCompanies) => ({
  type: SET_CAR_INSURANCE_COMPANIES,
  carInsuranceCompanies,
});

export const getCarInsuranceCompanies = () => (dispatch) => {
  Api.getInsuranceCompanies().then((res) => {
    const companies = res.data.map((x) => ({
      key: x.insuranceCompanyId,
      value: x.name,
    }));
    dispatch(setCarInsuranceCompanies(companies));
  });
};

export const getPersonNameRequest = () => ({
  type: GET_PERSON_NAME_REQUEST,
});

export const getPersonNameFailure = (error) => ({
  type: GET_PERSON_NAME_FAILURE,
  error,
});

const getConsolidationSellerNameSuccess = (name) => ({
  type: GET_SELLER_NAME_SUCCESS,
  name,
});

export const getConsolidationSellerName = (id) => (dispatch) => {
  dispatch(getPersonNameRequest());
  Api.getPersonName(id)
    .then((res) => {
      dispatch(getConsolidationSellerNameSuccess(res.data));
    })
    .catch((err) => {
      dispatch(getPersonNameFailure(err));
    });
};

export const setSellerSsnAndGetName = (ssn) => (dispatch) => {
  if (!ssn) return;
  
  dispatch(setSsn(ssn));
  dispatch(getConsolidationSellerName(ssn));
};

export const resetConsolidationState = () => ({
  type: RESET_CONSOLIDATION_STATE,
});

// New action creators for current collateral car info
const currentCarInfoRequest = () => ({
  type: CURRENT_CAR_INFO_REQUEST,
});

const currentCarInfoSuccess = (car) => ({
  type: CURRENT_CAR_INFO_SUCCESS,
  car,
});

const currentCarInfoFailure = (error) => ({
  type: CURRENT_CAR_INFO_FAILURE,
  error,
});

// New action to get car info for current collateral
export const getCurrentCarInfo = (id) => (dispatch, getState) => {
  dispatch(currentCarInfoRequest());
  const { year, serialNumber } = getState().app;
  return Api.getVehicle(id, year, serialNumber)
    .then((res) => {
      dispatch(currentCarInfoSuccess(res.data));
    })
    .catch((err) => {
      dispatch(currentCarInfoFailure(err));
    });
};

export const setDepositPercentage = (percentage) => ({
  type: SET_DEPOSIT_PERCENTAGE,
  percentage,
});

export const setLoanType = (productType) => (dispatch, getState) => {
  const currentType = getState().consolidation.productType;
  
  if (currentType !== productType) {
    dispatch({
      type: SET_LOAN_TYPE,
      productType: productType,
    });
    
    dispatch(calcConsolidation());
  }
};

export const clearRmbalFlags = () => ({
  type: CLEAR_RMBAL_FLAGS,
});

export const clearAllApplicantData = () => (dispatch) => {
  // Clear app state - use setField actions to clear specific fields that RmBal populates
  dispatch(setApplicantField('ssn', ''));
  dispatch(setApplicantField('email', ''));
  dispatch(setApplicantField('telephone', ''));
  dispatch(setApplicantField('name', ''));
  
  dispatch(setSecondApplicantField('ssn', ''));
  dispatch(setSecondApplicantField('email', ''));
  dispatch(setSecondApplicantField('telephone', ''));
  dispatch(setSecondApplicantField('name', ''));
  
  dispatch(setGuarantorField('ssn', ''));
  dispatch(setGuarantorField('email', ''));
  dispatch(setGuarantorField('telephone', ''));
  dispatch(setGuarantorField('name', ''));
  
  dispatch(setSecondGuarantorField('ssn', ''));
  dispatch(setSecondGuarantorField('email', ''));
  dispatch(setSecondGuarantorField('telephone', ''));
  dispatch(setSecondGuarantorField('name', ''));
  
  // Clear consolidation state flags and applicant data
  dispatch(clearRmbalFlags());
};
